import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Typography
} from "@mui/material";

import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CloseIcon from "@mui/icons-material/Close";

const BranchSelectModal = ({
    open,
    onClose,
    branches,
    onSelect
}) => {

    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden"
                }
            }}
        >

            {/* HEADER */}

            <DialogTitle
                sx={{
                    backgroundColor: "#002147",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    py: 1.5,
                    px: 2
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    }}
                >

                    <AccountTreeIcon />

                    <Typography
                        sx={{
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            fontSize: "1rem"
                        }}
                    >
                        Select Branch
                    </Typography>

                </Box>

                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        color: "#fff"
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>

            </DialogTitle>

            {/* CONTENT */}

            <DialogContent
                sx={{
                    p: 0,
                    maxHeight: 450
                }}
            >

                {branches.length === 0 ? (

                    <Box
                        sx={{
                            py: 5,
                            px: 2,
                            textAlign: "center"
                        }}
                    >

                        <Typography
                            sx={{
                                color: "#666",
                                fontFamily: "Poppins"
                            }}
                        >
                            No branches available
                        </Typography>

                    </Box>

                ) : (

                    <>

                        {/* COUNT */}

                        {/* <Box
                            sx={{
                                px: 2,
                                py: 1.5,
                                borderBottom: "1px solid #eee",
                                backgroundColor: "#fafafa"
                            }}
                        >

                            <Chip
                                label={`${branches.length} Branches`}
                                size="small"
                                sx={{
                                    backgroundColor: "#00214715",
                                    color: "#002147",
                                    fontWeight: 600,
                                    fontFamily: "Poppins"
                                }}
                            />

                        </Box> */}

                        {/* BRANCH LIST */}

                        <List sx={{ py: 0 }}>

                            {branches.map((branch, index) => (

                                <ListItemButton
                                    key={branch}
                                    onClick={() => onSelect(branch)}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        borderBottom:
                                            index !== branches.length - 1
                                                ? "1px solid #f1f1f1"
                                                : "none",
                                        transition: "0.2s",

                                        "&:hover": {
                                            backgroundColor: "#00214710"
                                        }
                                    }}
                                >

                                    <ListItemText
                                        primary={branch}
                                        primaryTypographyProps={{
                                            fontFamily: "Poppins",
                                            fontSize: "0.95rem",
                                            fontWeight: 500,
                                            color: "#222"
                                        }}
                                    />

                                </ListItemButton>

                            ))}

                        </List>

                    </>

                )}

            </DialogContent>

        </Dialog>
    );
};

export default BranchSelectModal;